import { useContext } from 'react';

import { GatsbyImg } from 'components';
import { LocaleContext } from 'components/rebrand/Layout';
import { Link } from 'components/rebrand/Link';

import { ISanityImage, ISanitySlug } from 'typescriptDefs';

import { getSanityImageUrl } from 'helpers/sanityImageBuilder';

type Props = {
  bio: string;
  img: ISanityImage;
  isGROQ: boolean;
  name: string;
  slug: ISanitySlug;
};

export const AuthorBio = ({ bio, img, isGROQ, slug }: Props) => {
  const locale = useContext(LocaleContext);
  return (
    <div className="flex flex-row gap-16 pb-48">
      {isGROQ && img.url ? (
        <img
          src={getSanityImageUrl(img.url, {
            width: 56,
            height: 56,
          })}
          className="h-56 w-56 min-w-56 max-w-56 rounded-full"
        />
      ) : (
        <GatsbyImg image={img.asset.gatsbyImageData} className="h-56 w-56 min-w-56 max-w-56 rounded-full" />
      )}
      <div>
        <h4 className="text-lg font-medium leading-normal text-grey-500">
          {{ en: 'About the author', fr: "À propos de l'auteur" }[locale]}
        </h4>
        <p className="mb-24 text-md leading-normal text-grey-400">{bio}</p>
        <Link variant="secondary" href={`/author/${slug.current}/`} className="text-md font-medium">
          {{ en: 'Read more about this author', fr: 'En savoir plus sur cet auteur' }[locale]}
        </Link>
      </div>
    </div>
  );
};
